import { getLayoutData, getPageData, getPages } from './api/api';
import { useRouter } from 'next/router';
import { FRAGMENTS } from '@repo/ui/lib';
import { DIGITAL_FRAGMENTS } from '@/lib';
import dynamic from 'next/dynamic';
import ExtendedContent from '@/components/common/ExtendedContent';

const StickyHeading = dynamic(() => import('@repo/ui/src/components/StickyHeading'), {
	ssr: false,
});

export default function Page({ data, locale }) {
	const { asPath } = useRouter();
	const isServicePage = asPath.includes('/services');
	const contentData = data?.content || [];
	const stickyHeadingsSelectors = data?.stickyHeadingsSelector || [];
	return (
		<>
			<StickyHeading stickyHeadingsSelectors={stickyHeadingsSelectors} isVisible />
			<ExtendedContent content={contentData} locale={locale} isServicePage={isServicePage} />
		</>
	);
}

const PAGE_CONTENT_TYPE = 'allDigitalSinglePages';

const pathsQuery = `
	query GetHomePageData($locale: SiteLocale) {
		${PAGE_CONTENT_TYPE}(locale: $locale, filter: {slug: {notIn: ["home", "story","404"]}}, first: 100) {
            name
            slug
            description
		}
	}
`;

const propsQuery = `
	query GetSinglePage($slug: String, $locale: SiteLocale)  {
		${PAGE_CONTENT_TYPE}(locale: $locale, filter: {slug: {eq: $slug}}) {
            name
            slug
            description
            ${FRAGMENTS.SEO_META_FRAGMENT}
			${FRAGMENTS.THEME_FRAGMENT}
            ${DIGITAL_FRAGMENTS.BREADCRUMBS_FRAGMENT}
			${DIGITAL_FRAGMENTS.STICKY_HEADING_FRAGMENT}
			content {
				__typename
				
				${FRAGMENTS.VIDEO_BANNER_FRAGMENT}
				${FRAGMENTS.PLEO_BRANCHES_MODULE_FRAGMENT}
				${FRAGMENTS.FORM_MODULE_FRAGMENT}
				${FRAGMENTS.DESCRIPTION_AND_SLOGAN_MODULE_FRAGMENT}
				${FRAGMENTS.HOW_WE_WORK_MODULE_FRAGMENT}
				${FRAGMENTS.HORIZONTAL_HEADER_MODULE_FRAGMENT}
				${FRAGMENTS.PLEO_CONTEXT_MODULE_FRAGMENT}
				${FRAGMENTS.TEXT_MODULE_FRAGMENT}
				${FRAGMENTS.QUICK_CONTACT_MODULE_FRAGMENT}
				${FRAGMENTS.WHO_WE_WORKED_WITH_MODULE_FRAGMENT}
				${FRAGMENTS.SERVICES_CARDS_MODULE_FRAGMENT}
				${FRAGMENTS.AREA_OF_EXPERTISE_MODULE_FRAGMENT}
				${FRAGMENTS.CARRER_MODULE_FRAGMENT}
				
				${DIGITAL_FRAGMENTS.CHECK_OTHERS_FRAGMENT}
				${DIGITAL_FRAGMENTS.FAQ_FRAGMENT}
				${DIGITAL_FRAGMENTS.SOCIAL_MEDIA_FRAGMENT}
				${DIGITAL_FRAGMENTS.ABOUT_TEAM_FRAGMENT}
				${DIGITAL_FRAGMENTS.SINGLE_ASSET_FRAGMENT}
                ${DIGITAL_FRAGMENTS.TILES_MODULE_FRAGMENT}
                ${DIGITAL_FRAGMENTS.TILES_WITH_DESCRIPTION_FRAGMENT}
               
			}
		}
	}
`;

export async function getStaticProps({ params, locale }) {
	const { slug } = params;
	const data = await getPageData(PAGE_CONTENT_TYPE, slug, propsQuery, locale);
	const { globals, cookies, menu, footer } = await getLayoutData(locale);
	return {
		props: {
			data,
			globals,
			cookies,
			locale,
			menu,
			footer,
		},
		revalidate: 120,
	};
}

export async function getStaticPaths({ locales }) {
	const paths = [];
	for (const locale of locales) {
		const singlePages = await getPages(PAGE_CONTENT_TYPE, pathsQuery, locale);
		const single = singlePages
			.map((page) => {
				return {
					params: {
						slug: page.slug,
					},
					locale,
				};
			})
			.filter((el) => {
				return el !== null;
			});
		paths.push(...single);
	}
	return {
		paths,
		fallback: false,
	};
}
